<div class="footer text-white text-center">
  <div class="footer-quicklinks bg-primary w-100 d-none d-lg-block"></div>
  <div class="footer-text bg-black d-flex align-items-center justify-content-center">
    <div class="footer-content">
      <img class="footer-logo" src="assets/images/Logos/RedbullsFooterLogo.svg" draggable="false" />
    </div>
  </div>
</div>
